// Separates the app-level build/runtime flags (useReset, useVariable,
// globalTheme, ...) from the content-facing project context. Editor
// surfaces that render inside their OWN chrome (canvas, future embeds)
// must keep these flags out of the merged context — the chrome owns its
// own CSS reset / icon sprites / theme, and the project's values would
// override the chrome.
//
// For surfaces that mount the project as a standalone app (preview
// iframe, mermaid SSR), the flags stay with the project and this split
// isn't needed — createIframeApp + bundle.js apply them as-is.
//
// `pages` is split out separately because canvas routes project pages
// through its Collection grid (as thumbnails) rather than its own router.

export function splitProjectForEditor (project) {
  if (!project || typeof project !== 'object') {
    return { chromeFlags: {}, projectContent: {}, projectPages: {} }
  }
  const {
    useReset,
    useVariable,
    useFontImport,
    useIconSprite,
    useSvgSprite,
    useDocumentTheme,
    useDefaultIcons,
    useDefaultConfig,
    globalTheme,
    pages,
    ...projectContent
  } = project
  return {
    chromeFlags: {
      useReset,
      useVariable,
      useFontImport,
      useIconSprite,
      useSvgSprite,
      useDocumentTheme,
      useDefaultIcons,
      useDefaultConfig,
      globalTheme
    },
    projectContent,
    projectPages: pages || {}
  }
}
